/* jackpot-carousel.js */
/* countdown + ticker + 3-slide carousel, matched to CSS (100vw slides) */

/* ========== COUNTDOWN (same as yours) ========== */
function initCountdown() {
  const countdowns = document.querySelectorAll('[data-daily-uk18]');
  if (!countdowns.length) return;

  const TIMEZONE = 'Europe/London';
  const TARGET_HOUR = 18;

  function partsToObj(parts) {
    return parts.reduce((acc, p) => {
      if (p.type !== 'literal') acc[p.type] = p.value;
      return acc;
    }, {});
  }

  function getZoneOffsetMs(atDate, timeZone) {
    const fmt = new Intl.DateTimeFormat('en-GB', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    });
    const p = partsToObj(fmt.formatToParts(atDate));
    const zonedAsUTC = Date.UTC(
      Number(p.year),
      Number(p.month) - 1,
      Number(p.day),
      Number(p.hour),
      Number(p.minute),
      Number(p.second)
    );
    return atDate.getTime() - zonedAsUTC;
  }

  function nextLondonSixPmUtc(now = new Date()) {
    const fmt = new Intl.DateTimeFormat('en-GB', {
      timeZone: TIMEZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    });
    const pNow = partsToObj(fmt.formatToParts(now));
    const year = Number(pNow.year);
    const month = Number(pNow.month);
    const day = Number(pNow.day);

    const offsetTodayMs = getZoneOffsetMs(now, TIMEZONE);
    let targetUtcMs = Date.UTC(year, month - 1, day, TARGET_HOUR, 0, 0) - offsetTodayMs;

    if (now.getTime() >= targetUtcMs) {
      const tomorrow = new Date(now.getTime() + 24 * 60 * 60 * 1000);
      const offsetTomorrowMs = getZoneOffsetMs(tomorrow, TIMEZONE);
      const pTom = partsToObj(fmt.formatToParts(tomorrow));
      const y2 = Number(pTom.year), m2 = Number(pTom.month), d2 = Number(pTom.day);
      targetUtcMs = Date.UTC(y2, m2 - 1, d2, TARGET_HOUR, 0, 0) - offsetTomorrowMs;
    }

    return targetUtcMs;
  }

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function updateCountdown() {
    const now = new Date();
    const targetUtcMs = nextLondonSixPmUtc(now);
    let diff = Math.max(0, targetUtcMs - now.getTime());

    const totalSecs = Math.floor(diff / 1000);
    const secs = totalSecs % 60;
    const totalMins = Math.floor(totalSecs / 60);
    const mins = totalMins % 60;
    const hrs = Math.floor(totalMins / 60);

    countdowns.forEach(el => {
      el.querySelectorAll('.js-hrs').forEach(h => (h.textContent = pad(hrs)));
      el.querySelectorAll('.js-mins').forEach(m => (m.textContent = pad(mins)));
      el.querySelectorAll('.js-secs').forEach(s => (s.textContent = pad(secs)));
    });
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);
}

/* ========== TICKER ========== */
function initTicker() {
  const track = document.querySelector('.jackpot-ticker__track');
  if (!track) return;

  const original = track.innerHTML;
  track.innerHTML = original + original;

  let pos = 0;
  const speed = 0.5;
  let halfWidth = 0;

  // measure after layout so Firefox has the real width
  requestAnimationFrame(() => {
    halfWidth = track.scrollWidth / 2 || 0;
  });

  function tick() {
    if (!halfWidth) {
      requestAnimationFrame(tick);
      return;
    }
    pos -= speed;
    if (Math.abs(pos) >= halfWidth) pos = 0;
    track.style.transform = 'translateX(' + pos + 'px)';
    requestAnimationFrame(tick);
  }

  requestAnimationFrame(tick);
}

/* ========== CAROUSEL ========== */
function initCarousel() {
  const track = document.getElementById('jackpot-slider-track');
  const slides = document.querySelectorAll('.jackpot-slide');
  const prevBtn = document.querySelector('.jackpot-nav--prev');
  const nextBtn = document.querySelector('.jackpot-nav--next');
  const dotsContainer = document.getElementById('jackpot-dots');

  if (!track || !slides.length) return;

  const total = slides.length;
  let current = 0;
  let autoTimer = null;
  const delay = 6000;

  // make sure we have a transition
  track.style.transition = 'transform .6s cubic-bezier(.16,1,.3,1)';

  // build dots safely
  let dots = [];
  if (dotsContainer) {
    dotsContainer.innerHTML = '';
    for (let i = 0; i < total; i++) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'jackpot-dot' + (i === 0 ? ' is-active' : '');
      dot.addEventListener('click', () => goToSlide(i, true));
      dotsContainer.appendChild(dot);
    }
    dots = dotsContainer.querySelectorAll('.jackpot-dot');
  }

  function updateDots(idx) {
    if (!dots || !dots.length) return;
    dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
  }

  function goToSlide(index, userTriggered) {
    current = (index + total) % total;
    // match CSS (each slide is 100vw)
    const offset = -current * 100;
    track.style.transform = 'translateX(' + offset + 'vw)';
    updateDots(current);
    if (userTriggered) restartAuto();
  }

  function nextSlide() {
    goToSlide(current + 1, false);
  }

  function prevSlide() {
    goToSlide(current - 1, false);
  }

  function restartAuto() {
    if (autoTimer) clearInterval(autoTimer);
    autoTimer = setInterval(nextSlide, delay);
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      nextSlide();
      restartAuto();
    });
  }
  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      prevSlide();
      restartAuto();
    });
  }

  // touch
  let startX = 0;
  let diff = 0;
  track.addEventListener('touchstart', e => {
    if (autoTimer) clearInterval(autoTimer);
    startX = e.touches[0].clientX;
    diff = 0;
  }, { passive: true });

  track.addEventListener('touchmove', e => {
    diff = e.touches[0].clientX - startX;
  }, { passive: true });

  track.addEventListener('touchend', () => {
    if (Math.abs(diff) > 50) {
      if (diff > 0) prevSlide();
      else nextSlide();
    }
    restartAuto();
  });

  // hover pause (desktop)
  const carousel = document.getElementById('jackpot-carousel');
  if (carousel) {
    carousel.addEventListener('mouseenter', () => {
      if (autoTimer) clearInterval(autoTimer);
    });
    carousel.addEventListener('mouseleave', () => {
      restartAuto();
    });
  }

  // start
  goToSlide(0, false);
  restartAuto();
}

/* ========== INIT (immediate + observer fallback) ========== */
function initJackpot() {
  initTicker();
  initCountdown();
  initCarousel();
}

(function boot() {
  const run = () => {
    // if the section is already in DOM, init now
    if (document.getElementById('jackpot-slider-track')) {
      initJackpot();
    } else {
      // else watch for it (Shopify sections can load late)
      const observer = new MutationObserver(() => {
        if (document.getElementById('jackpot-slider-track')) {
          observer.disconnect();
          initJackpot();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  };

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    run();
  } else {
    document.addEventListener('DOMContentLoaded', run);
  }
})();
